import { DateTime } from 'luxon';
import { PROPOSAL_DESCRIPTION_UNAVAILABLE } from './constants';
import { proposalDescription } from './offerScanPresentation';
import { MutedText } from './proposalStyles';
import { OfferProposal } from './types';

export const ProposalScanDetails = ({
  proposal,
}: {
  proposal: OfferProposal;
}): JSX.Element => {
  const captured = proposal.evidence
    .map((evidence) => DateTime.fromISO(evidence.observedAtUtc ?? ''))
    .filter((date) => date.isValid)
    .sort((left, right) => right.toMillis() - left.toMillis())[0];

  return (
    <MutedText>
      Latest evidence captured:{' '}
      {captured?.toLocaleString(DateTime.DATETIME_MED) ?? 'Unavailable'}
      {!proposalDescription(proposal) &&
        ` · ${PROPOSAL_DESCRIPTION_UNAVAILABLE}`}
    </MutedText>
  );
};
